import { schSiteInfluence, schSiteRating, schSiteView } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import { getAloftAreaJSONPropertyGridField } from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridFieldName,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const FeatureGridSiteSection = (props: PropertyGridSectionProps) => {
  const fields = useMemo(
    () => [
      getAloftAreaJSONPropertyGridField({
        fieldName: 'editableData.site.area',
        label: 'Site Size',
      }),
      {
        fieldName: 'editableData.site.influence' as PropertyGridFieldName,
        label: 'Site Influence',
        options: toOpts(schSiteInfluence.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.influenceRating' as PropertyGridFieldName,
        label: 'Site Influence Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.view' as PropertyGridFieldName,
        label: 'View',
        options: toOpts(schSiteView.options),
        autofillSubjectValue: true,
      },
      {
        fieldName: 'editableData.site.viewRating' as PropertyGridFieldName,
        label: 'View Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
      },
    ],
    [],
  );

  return <PropertyGridSection {...props} title="Site" fields={fields} />;
};
